export default "__VITE_ASSET__FnfkZ3uH__"